function calcRating(comments) {
    const ratings = comments.map(comment => comment.rating).filter(Boolean);
    const sum = ratings.reduce((a, b) => a + b, 0)
    return (sum / ratings.length) || null;
}

export default calcRating;
